import { BookingList2 } from "../../../components/Booking/BookingList";
import { EmptyContent } from "../../../components/EmptyContent";
import { ErrorMessage } from "views/components/Message";
import { Row } from "antd";
import { ScreenLayout } from "../../../components/ScreenLayout";
import { Spinner } from "../../../mobile/components/common";
import { useReservations } from "state/reservations/hooks";
import React from "reactn";
import { TemporaryUserInfo } from "views/components/TemporaryUserInfo";
import { useAuth } from "hooks/useAuth";

const Reservations = () => {
	const [myReservations, loading, error] = useReservations();
	const { isLoggedInTemporary } = useAuth();

	return (
		<ScreenLayout
			title="Mis Reservas"
			description="Revisa las reservas que has solicitado, aquí:"
			contentAligned={true}
		>
			{isLoggedInTemporary && myReservations.length === 0 ? (
				<TemporaryUserInfo
					isLoggedInTemporary={isLoggedInTemporary}
					desktop
				/>
			) : (
				<>
					{loading && <Spinner full></Spinner>}
					<ErrorMessage error={error} />
					{!loading && myReservations.length === 0 && (
						<EmptyContent description="No tienes reservas todavía..."></EmptyContent>
					)}
					{!loading && myReservations && (
						<Row align="middle" gutter={24}>
							{myReservations.map((r) => (
								<BookingList2 key={r.id} reservation={r} />
							))}
						</Row>
					)}
				</>
			)}
		</ScreenLayout>
	);
};

export default Reservations;
